/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { HotelsAndAttractionsVisitorCategorySection } from './hotelsAndAttractionsVisitorCategorySection';


export interface HotelsAndAttractions { 
    archived?: boolean;
    category?: HotelsAndAttractionsVisitorCategorySection;
    createdAt?: string;
    description?: string;
    id?: string;
    image?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    itemId?: number;
    link?: string;
    locked?: boolean;
    path?: string;
    price?: number;
    published?: boolean;
    readOnly?: boolean;
    sortOrder?: number;
    title?: string;
    type?: string;
    updatedAt?: string;
    version?: number;
    visitorSectionCategoryId?: number;
}
